module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/core-js/modules/_html.js
// module id = 163
// module chunks = 1